<!-- Modal Backdrop -->
@if (isModalOpen) {
<div class="modal-backdrop fade show" (click)="close()"></div>
}

<!-- Modal -->
@if (isModalOpen) {
<div class="modal fade show" [style.display]="'block'" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="false">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">{{ title }}</h5>
                <button type="button" class="btn-close" (click)="close()" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <p>{{ message }}</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary minw100 justify-content-center" (click)="close()">
                    {{ buttonText || 'OK' }}
                </button>
            </div>
        </div>
    </div>
</div>
}